import getText from "../../../../../utils/language.js"
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";
import ClientsDiffusorsList from "../../../tables/clientsdiffusors/clientsdiffusorslist.js";
import ColorComboBox from "../../../../../components/bases/selectcolor/selectcolor.js";

class ParamColorCombo extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)
        this.state = 
        {
            value: this.props.value,
            defaultvalue: this.props.value,
        }

        if ("defaultvalue" in this.props)
        {
            this.state.defaultvalue = this.props.defaultvalue;
            this.state.checkdefault = true;
        }

        this.handleComboBox = this.handleComboBox.bind(this)



    }
    handleComboBox(newvalue)
    {
        
        console.log("combox box new value ", newvalue)
        this.setState({value: newvalue});
        this.props.onchange(this.props.paramnumber, newvalue);
    }

    render()
    {
        const selectBox = (
        <ColorComboBox
            value={this.props.value} 
            onChange = {this.handleComboBox}
        />
        );                

        const title = getText(this.props.text.cat, this.props.text.scat, this.context.language);

        
        var tcolor="white";
        var checkdefault = false;
        var defaultvalue = this.props.value;
        if (this.props.coid > 0)
        {
            if ("defaultvalue" in this.props)
            {
                defaultvalue = this.props.defaultvalue;
                checkdefault = true;
            }
        }

        if (checkdefault)
        {
            if (this.state.value != defaultvalue)
                tcolor="#FF9800";
        }


        return(
            <div className ="tabsettingslidertext">
                <label style={{color:tcolor}}>
                {title} &nbsp;
                </label>
                {selectBox}
                
           </div>
        )
    }
}

export default ParamColorCombo
